module.exports = __webpack_public_path__ + "static/img/digitalsystem2.adb03ab2.png";